import { render, staticRenderFns } from "./PreviewColumn.vue?vue&type=template&id=08d1d6f6"
import script from "./PreviewColumn.vue?vue&type=script&lang=ts"
export * from "./PreviewColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports